export const viewListMaxTime = 10 * 60 * 1000; // 10 min
